import React, { useEffect, useState } from "react";
import { Table, Tooltip, Col, Form, Input, Row } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import ImageUploading from "react-images-uploading";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { toast } from "react-toastify";
import { URL } from "../../Redux/common/url";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { DownloadOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import moment from "moment";
import Api from "../../Redux/common/api";
import SchemePdfGanerator from "../Product/SchemePdfGanerator";
function Category() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const users_list = useSelector((state) =>
    state?.allapi?.category_list ? state?.allapi?.category_list : {}
  );

  const listdata = users_list?.docs ? users_list?.docs : [];

  const [search, setsearch] = useState("");
  const [startDate2vs, setStartDate2vs] = useState("");
  const [startDate2vse, setStartDate2vse] = useState("");
  console.log(startDate2vs);
  console.log(startDate2vse);



  const [showDelelt, setShowDelete] = useState(false);

  const handleCloseDelete = () => setShowDelete(false);
  const [cateID, setcateID] = useState("");

  const hendleDelete = (e) => {
    console.log(e);
    // deleteProduct
    setShowDelete(false);
    dispatch(allapiAction.delete_category({ productId: e, pageNo: page }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);

  const hendleModalShow = (e) => {
    // setShowDelete(true)
    setcateID(e);
    setIsModalOpen(true);
  };

  const [cateDetail, setcateDetail] = useState({});

  console.log(cateDetail);

  const [images, setImages] = useState([]);
  const maxNumber = 1;

  console.log(images);

  const [Imagesfe, setImagesfe] = useState("");
  const onChangefe = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log(imageList, addUpdateIndex)
    setImagesfe(imageList);
  };

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  const hendleTochangeCategory = (e) => {
    const { name, value } = e.target;
    setcateDetail({ ...cateDetail, [name]: value });
  };

  const showModal = (e) => {
    console.log(e);
    setcateDetail(e);

    setImagesfe([{ data_url: URL.API_BASE_URL + e.image }]);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    const data = new FormData();
    data.append("name", cateDetail?.name);
    // data.append('description', categoryUpPage)
    data.append("meta_title", cateDetail?.meta_title);
    data.append("meta_description", cateDetail?.meta_description);
    data.append("cate_id", cateDetail?._id);
    data.append("pageNo", page);
    if (Imagesfe[0]?.file) {
      // roledata?.role_name
      data.append("image", Imagesfe[0]?.file);
    }
    dispatch(allapiAction.update_category(data));
    // dispatch(adminAction.getRoleList('dhsg'))
    setIsModalOpen(false);
    return () => {};
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [cateDetailAdd, setcateDetailAdd] = useState({});
  console.log(cateDetailAdd);
  const [startDate, setStartDate] = useState(new Date());
  const hendleTochangeCategoryAdd = (e) => {
    const { name, value } = e.target;
    setcateDetailAdd({ ...cateDetailAdd, [name]: value });
  };

  const showModalAdd = (e) => {
    console.log(e);
    setcateDetail(e);
    setAddModalOpen(true);
  };

  const [aboutPage, setaboutPage] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [cateDetail2, setcateDetail2] = useState({});
    const hendleTochangefiles = (e) => {
      const { name, files } = e.target;
  
      setSelectedFile(files);
      setcateDetail2({ ...cateDetail2, [name]: files });
    };
  const handleOkAdd = async() => {
    if (!cateDetailAdd?.name) {
      toast.error("please enter name");
    } else if (!cateDetailAdd?.loaction) {
      toast.error("please enter loaction");
    } else {
      const data = new FormData();
      const data1 = new FormData();
      data.append("page", 1);
      data.append("name", cateDetailAdd?.name);
      // data.append('description', aboutPage)
      data.append("meta_title", cateDetailAdd?.meta_title);
      data.append("meta_description", cateDetailAdd?.meta_description);
      data.append("loaction", cateDetailAdd?.loaction);
      data.append("khasranumber", cateDetailAdd?.khasranumber);
      data.append("sanyojakName", cateDetailAdd?.sanyojakName);
      data.append("vyavsthapakName", cateDetailAdd?.vyavsthapakName);
      data.append("kashtkarName", cateDetailAdd?.kashtkarName);
      data.append("areaBigha", cateDetailAdd?.areaBigha);
      data.append("schemerate", cateDetailAdd?.schemerate);
      data.append("developmentCharges", cateDetailAdd?.developmentCharges);
      data.append("shopRate", cateDetailAdd?.shopRate);
      data.append("totalPlotArea", cateDetailAdd?.totalPlotArea);
      data.append("totalRoadArea", cateDetailAdd?.totalRoadArea);
      data.append("RegDate", startDate.toISOString().split("T")[0]);
      // data.append('categoryName', 'test cate')
      data.append("parentId", "11");
      data.append("sellerId", "20");
      // data.append("image", images[0]?.file);

   const response = await   dispatch(allapiAction.create_category(data));


           if (selectedFile?.length > 0) {
              for (let i = 0; i < selectedFile?.length; i++) {
                data1.append("images", selectedFile[i]);
              }
              // data.append("propertyId", response?.data?._id);
              data1.append("schemeId", response?.data?._id);
              const response1 = await dispatch(allapiAction.propertyDocumentAdd(data1));
            }

      setcateDetailAdd({
        name: "",
        loaction: "",
        khasranumber: "",
        sanyojakName: "",
        vyavsthapakName: "",
        kashtkarName: "",
        areaBigha: "",
      });

      if (startDate2vs ||startDate2vse) {
        const obj = { page: page };
        if (startDate2vs) {
          obj.startDate = startDate2vs;
        }
        if (startDate2vse) {
          obj.endDate = startDate2vse;
        }
        if (search) {
          obj.search = search;
        }
        dispatch(allapiAction.allcategorySearch(obj));
      } else {
        
        dispatch(allapiAction.allcategory(1));
      }
      // dispatch(adminAction.getRoleList('dhsg'))
      setAddModalOpen(false);
      return () => {};
    }
  };

  const handleCancelAdd = () => {
    setAddModalOpen(false);
  };

  const { confirm } = Modal;

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusCategory({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <div style={{ width: "100px" }}>
    //           <img style={{ width: "100%" }} src={URL?.API_BASE_URL + item?.image} alt="" />
    //         </div>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Area( Bigha)",
      dataIndex: "areaBigha",
      key: "areaBigha",
    },
    {
      title: "Loaction",
      dataIndex: "loaction",
      key: "loaction",
    },
    // {
    //   title: "Scheme Register date",
    //   dataIndex: "RegDate",
    //   key: "RegDate",
    // },
    {
      title: "Scheme Register date",
      dataIndex: "RegDate",
      key: "RegDate",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer"
              // onClick={() => navigate(`/users/contact/${item?.id}`)}
            >
              {moment(item?.RegDate).format(" DD/MM/YYYY ")}
            </span>
          </>
        );
      },
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title={item?.status}>
    //           <button
    //             className={
    //               item?.is_status == "Active"
    //                 ? "success-button ml-3"
    //                 : "delete-button ml-3"
    //             }
    //             onClick={() =>
    //               hendleToStatus(
    //                 item?._id,
    //                 item?.is_status == "Active" ? "Inactive" : "Active"
    //               )
    //             }
    //           >
    //             {item?.is_status}
    //           </button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showModal(item);
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                                hendleModalShow(item?.id)
                              }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            <Tooltip title="View">
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/SchemeDetails/" + item?._id);
                }}
              >
                <SvgIcon.Visibility className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
          </>
        );
      },
    },
  ];

  // const [page, setPage] = useState(1);




  useEffect(() => {
    if (startDate2vs ||startDate2vse) {
      const obj = { page: page };
      if (startDate2vs) {
        obj.startDate = startDate2vs;
      }
      if (startDate2vse) {
        obj.endDate = startDate2vse;
      }
      if (search) {
        obj.search = search;
      }
      dispatch(allapiAction.allcategorySearch(obj));
    } else {
      
      dispatch(allapiAction.allcategory(1));
    }

    return () => {};
  }, [startDate2vse, startDate2vs]);
  const handleChange = (e) => {
    console.log(e);
    setsearch(e);
    setPage(1);

    const obj = { page: 1 };
    if (startDate2vs) {
      obj.startDate = startDate2vs;
    }
    if (startDate2vse) {
      obj.endDate = startDate2vse;
    }
    if (e) {
      obj.search = e;
    }
    dispatch(allapiAction.allcategorySearch(obj));
    // if (e) {
    //
    //   return () => {};
    // } else {
    //   dispatch(allapiAction.allcategory(1));

    //   return () => {};
    // }
    // getuserListSearch
    // &user_id=${data?.user_id}&search=${data?.user_id}
  };

  const hendlePahegi = (e) => {
    setPage(e);
    const obj = { page: e };
    if (startDate2vs) {
      obj.startDate = startDate2vs;
    }
    if (startDate2vse) {
      obj.endDate = startDate2vse;
    }
    if (search) {
      obj.search = search;
    }
    dispatch(allapiAction.allcategorySearch(obj));
    // if (search) {
    //   dispatch(allapiAction.allcategorySearch({ page: e, search: search }));
    //   return () => {};
    // } else {
    //   dispatch(allapiAction.allcategory(e));

    //   return () => {};
    // }
  };

  const getRowClassName = (record) => {
    // Define your condition for changing the row color here
    return record.type === "cr" ? "active" : "inactive";
  };

  const downloadSchemes = async () => {
    const token = localStorage.getItem("admin_token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const response = await Api.get(`${URL.getcateAllList}`, config);
    const data = response.data?.data;

    if (data.length === 0) {
      toast.error("No Schemes found");
    } else {
      let schemes = data.map((item, i) => {
        return {
          ["Sr. No. "]: i + 1,
          ["Scheme name"]: item?.name,
          ["Area( Bigha)"]: item?.areaBigha,
          ["Loaction"]: item?.loaction,
          ["Scheme Register date"]: moment(item?.RegDate).format(
            " DD/MM/YYYY "
          ),
        };
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(schemes);




      const colWidths = Object.keys(schemes[0]).map((key) => {
        const maxContentLength = Math.max(
          key.length,
          ...schemes.map((scheme) => (scheme[key] ? scheme[key].toString().length : 0))
        );
        return { width: maxContentLength + 2 }; // Adding 2 for padding
      });
  
      worksheet["!cols"] = colWidths;

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "Schemes.xlsx");
    }
  };
  return (
    <div>
      {/* update */}
      <Modal
        title="Update Category"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <ImageUploading
            // multiple
            value={Imagesfe}
            onChange={onChangefe}
            maxNumber={maxNumber}
            dataURLKey="data_url"
            acceptType={["png", "jpeg", "jpg", "webp"]}
            // acceptType={['jpg']}
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper">
                <button
                  style={isDragging ? { color: "red" } : {}}
                  onClick={onImageUpload}
                  {...dragProps}
                  className="btn btn-secondary"
                >
                  Choose image
                </button>
                &nbsp;
                <button
                  className="btn btn-secondary"
                  onClick={onImageRemoveAll}
                >
                  Remove all images
                </button>
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img src={image.data_url} alt="" width="100" />
                    <div className="image-item__btn-wrapper">
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageUpdate(index)}
                      >
                        Update
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageRemove(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ImageUploading>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="name"
            name="name"
            value={cateDetail?.name}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta title"
            name="meta_title"
            value={cateDetail?.meta_title}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta description"
            name="meta_description"
            value={cateDetail?.meta_description}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
      </Modal>

      {/* create */}
      <Modal
        title="Create New Scheme"
        open={addModalOpen}
        onOk={handleOkAdd}
        onCancel={handleCancelAdd}
        width={900}
      >
        <Row>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Scheme Name</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="name"
              name="name"
              value={cateDetailAdd?.name}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Loaction</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="loaction"
              name="loaction"
              value={cateDetailAdd?.loaction}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Khasra number</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="khasranumber"
              name="khasranumber"
              value={cateDetailAdd?.khasranumber}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Sanyojak name</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Sanyojak name"
              name="sanyojakName"
              value={cateDetailAdd?.sanyojakName}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Vyavsthapak name</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="vyavsthapak name"
              name="vyavsthapakName"
              value={cateDetailAdd?.vyavsthapakName}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Kashtkar name</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="kashtkar name"
              name="kashtkarName"
              value={cateDetailAdd?.kashtkarName}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          {/* <Col lg={6} md={6} sm={6} xs={6}>
          
            <div className="text-end mr-5 mt-15">Area (Bigha)</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="area bigha"
              name="areaBigha"
              value={cateDetailAdd?.areaBigha}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col> */}
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15"> Reg. Date</div>
          </Col>
          <Col lg={18} md={18} sm={18} xs={18}>
            <DatePicker
              className="form-control mt-5"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd/MM/yyyy"
            />
          </Col>

          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Scheme Area (Bigha)</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="area bigha"
              name="areaBigha"
              value={cateDetailAdd?.areaBigha}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Scheme Rate</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Scheme rate"
              name="schemerate"
              type="number"
              value={cateDetailAdd?.schemerate}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Development Charges</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Development Charges"
              name="developmentCharges"
              type="number"
              value={cateDetailAdd?.developmentCharges}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Shop Rate</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Shop Rate"
              name="shopRate"
              type="number"
              value={cateDetailAdd?.shopRate}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Total Plot Area</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Total Plot Area"
              name="totalPlotArea"
              type="number"
              value={cateDetailAdd?.totalPlotArea}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <div className="text-end mr-5 mt-15">Total Raod Area</div>
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Total Road Area"
              name="totalRoadArea"
              type="number"
              value={cateDetailAdd?.totalRoadArea}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>

            <Col lg={24} md={24} sm={24} xs={24}>
                      <div className=" mr-5 mt-15"> Select Document</div>
                    </Col>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <input
                        autoComplete="new-off"
                        className="form-control mt-8"
                        placeholder="images"
                        name="images"
                        type="file"
                        accept="image/*"
                        multiple
                        value={cateDetailAdd?.fullName}
                        onChange={(e) => {
                          hendleTochangefiles(e);
                        }}
                      />
                    </Col>
        </Row>
      </Modal>

      <div className="flex">
        <div>
          <HeadingBack
            title={"Scheme"}
            subHeading={`Total ${users_list?.totalDocs || 0} Scheme`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <label>Search</label>
          <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          />
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <label>From Date</label>
          <div className="input-field">
            <i className="fas fa-calendar-check-o"></i>
            <input
              type="date"
              required=""
              name="dob"
              placeholder="Enter dob"
              onChange={(e) => {
                setStartDate2vs(e?.target?.value);
              }}
            />
          </div>
        </Col>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <label>To Date</label>
          <div className="input-field">
            <i className="fas fa-calendar-check-o"></i>
            <input
              type="date"
              required=""
              name="dob"
              placeholder="Enter dob"
              onChange={(e) => {
                setStartDate2vse(e?.target?.value);
              }}
            />
          </div>

         
        </Col>
        <div className="flex1 flex justify-content-end align-items-center">
          <SchemePdfGanerator />
          <Tooltip title="Download" placement="topLeft">
            <Button
              type="primary"
              className=" ml-10"
              icon={<DownloadOutlined />}
              onClick={downloadSchemes}
            >
              Export Schemes
            </Button>
          </Tooltip>
          <Tooltip title="Add">
            <span className="jop_btn ml-10" onClick={() => showModalAdd()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <Table
          rowClassName={getRowClassName}
          dataSource={listdata}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: users_list?.totalDocs ? users_list?.totalDocs : 0,
          }}
        />
      </div>
    </div>
  );
}

export default Category;
